<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('profile.software.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.software.fao') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.fao"
                :error-messages="faoErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.software.licence') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.licence"
                :error-messages="licenceErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">

        </v-col>

      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'SoftwareForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.softwareVersionsGetSelectItems();
  },
  data() {
    return {
        name: null,
        fao: null,
        licence: null,
        softwareVersions: null,
    };
  },
  computed: {
      ...mapFields('softwareversion', {
        softwareVersionsSelectItems: 'selectItems'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    softwareVersionsErrors() {
      const errors = [];

      if (!this.$v.item.softwareVersions.$dirty) return errors;

      has(this.violations, 'softwareVersions') && errors.push(this.violations.softwareVersions);


      return errors;
    },
    faoErrors() {
      const errors = [];
      if (!this.$v.item.fao.$dirty) return errors;
      has(this.violations, 'fao') && errors.push(this.violations.fao);
      return errors;
    },
    licenceErrors() {
      const errors = [];
      if (!this.$v.item.licence.$dirty) return errors;
      has(this.violations, 'licence') && errors.push(this.violations.licence);
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        softwareVersionsGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      fao: {
      },
      licence: {
      },
      softwareVersions: {
      },
    }
  }
};
</script>
